import React, { useEffect, useRef, useState } from "react";
import BigNumber from "./BigNumber";
import FactModal from "./FactModal";
import { facts } from "./facts";

const EasterEgg = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [start, setStart] = useState(() =>
    Math.floor(Math.random() * facts.length),
  );
  const [cursor, setCursor] = useState(0);
  const triggerRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (!isOpen) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  const openModal = () => {
    triggerRef.current = document.activeElement as HTMLElement;
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    triggerRef.current?.focus();
  };

  const showNextFact = () => {
    if (cursor === facts.length - 1) {
      setStart(Math.floor(Math.random() * facts.length));
      setCursor(0);
      return;
    }

    setCursor(cursor + 1);
  };

  return (
    <>
      <BigNumber onClick={openModal} />
      <FactModal
        fact={facts[(start + cursor) % facts.length]}
        count={cursor + 1}
        total={facts.length}
        isOpen={isOpen}
        onClose={closeModal}
        onNext={showNextFact}
      />
    </>
  );
};

export default EasterEgg;
